// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"questionTitle_wrapper__DKUMg","label":"questionTitle_label__36NAT","title":"questionTitle_title__ZkWqS"};